import React from "react";

import styles from "./Row.module.scss";

/**
 * @param {String} [className] - additional className to add
 * @param {*} children - props.children
 */
const Row = ({ className, children }) => {
    return <div className={`${styles.row} ${className || ""}`}>{children}</div>;
};

export default Row;
